import { render, staticRenderFns } from "./SitePolicy.vue?vue&type=template&id=4543deb0&"
import script from "./SitePolicy.vue?vue&type=script&lang=ts&"
export * from "./SitePolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports